export const GB6400_PROMO = {
  dateStart: '2024-10-07 00:00:00',
  dateEnd: '2024-12-03 23:59:00',
  regulation: '/files/plus/Regulamin_Promocji_Nawet_6400_GB_Plus.pdf'
}

export const PROMO_AUTOTOPUP = {
  dateStart: '2025-01-08 00:00:00',
  dateEnd: null
}
